import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface ProgramadorEnviosModuleGateProps {
  children: React.ReactNode;
}

const ProgramadorEnviosModuleGate: React.FC<ProgramadorEnviosModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="programador-envios">{children}</TenantModuleGate>
);

export default ProgramadorEnviosModuleGate;
